<template>
  <div class="dialog">
    <el-dialog :title="title" width="650px" :visible.sync="hide" :before-close="handleClose" :close-on-click-modal="false">
      <div slot="title" class="headers">
        <slot name="header"></slot>
      </div>
      <div class="bodys">
        <slot name="body"></slot>
      </div>
      <div class="dialog-footer">
        <slot name="footer"></slot>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
export default {
  props: ["hide"],
  data() {
    return {
      value: "",
      show: true,
      title: "标题",
      text: "这是一段文本"
    };
  },
  methods: {
    handleClose() {
      this.$emit("handleClick", false);
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/css/edit.less";
/deep/ .el-dialog {
  margin-top: 0 !important;
  height: 400px;
  top: calc(50% - 200px);
  border-radius: 10px;
}
/deep/ .el-dialog__header {
  // background-color: @blue;
  height: 60px;
  box-sizing: border-box;
  padding: 0 16px;
  line-height: 60px;
  font-size: 1.18rem;
  color: #111;
  border-bottom: 1px solid #F5F5F5;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    top: 18px;
    .el-dialog__close {
      font-size: 1.18rem;
      border-radius: 50%;
      padding: 2px;
    }
  }
}
/deep/ .el-dialog__body {
  padding: 0 !important;
  .bodys {
    box-sizing: border-box;
    padding: 24px 0;
  }
}
.el {
  position: relative;
}
.bodys {
  overflow: auto;
  //   height: 228px;
  height: 274px;
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 10px 16px;
  //   height: 70px;
  border: 0;
  box-sizing: border-box;
}
.dialog-footer {
  /deep/ .el-button--small {
    min-width: 1rem;
    height: 0.4rem;
    font-size: 0.16rem;
  }
}
</style>